// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1W_QC","title":"AfterFrontImage_title__1hZWo"};